
<template>
  <div class="ToIntoing">
    <CustomHead srcName="loading.png">
      <div class="Transferring_in">系统匹配中…</div>
      <div class="Submitted">正在为您智能匹配产品…</div>
    </CustomHead>
  </div>
</template>
<script>
import CustomHead from '@/components/CustomHead.vue';

export default {
  name: 'maching',
  data() {
    return {
    };
  },
  components: {
    CustomHead,
  },
  mounted() {
    this.startMatch();
  },
  methods: {
    startMatch() {
      console.log('我开始匹配了');
      const {
        corpName, taxNo, borrowerName, borrowerType,
      } = this.$router.currentRoute.query;
      const context = this;
      this.$api.InteligentMatchPage.recommendResult({
        corpName, taxNo, borrowerName, borrowerType,
      }).then((res) => {
        if (res.success) {
          if (res.data.result) {
            setTimeout(() => {
              context.$router.push(`/supermarket/v2/matchSuccessful?corpName=${corpName}&taxNo=${taxNo}&borrowerName=${borrowerName}&borrowerType=${borrowerType}`);
            }, 2000);
          } else if (res.data.resultType === '2') {
            setTimeout(() => {
              context.$router.push(`/supermarket/v2/UnableEvaluate?corpName=${corpName}&taxNo=${taxNo}`);
            }, 2000);
          } else {
            setTimeout(() => {
              context.$router.push(`/supermarket/v2/noMatchInfo?corpName=${corpName}&taxNo=${taxNo}`);
            }, 2000);
          }
        } else {
          this.$toast(res.returnMessage || '匹配失败');
        }
      });
    },
  },
};
</script>
<style scoped>
.Transferring_in {
  font-family: PingFangSC-Medium;
  font-size: 17px;
  color: #1c2438;
  margin: 20px 0 8px 0;
}
.Submitted {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #9ea7b4;
}
@keyframes load-effect {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
